import React from 'react';
import clsx from 'clsx';
import Link from './Link';

const Item = ({ to, href, active, className, children, ...rest }) => (
  <Link
    to={to || href}
    role="tab"
    aria-selected={active ? true : undefined}
    aria-current={active ? 'page' : undefined}
    bare
    className={clsx(
      'outline-none inline-flex h-8 items-center rounded-md px-3 text-sm font-medium text-sidebar-foreground transition-colors hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 focus-visible:ring-sidebar-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
      active && 'bg-sidebar-accent text-sidebar-accent-foreground',
      className,
    )}
    {...rest}
  >
    {children}
  </Link>
);

const NavTabs = ({ children, className, ...rest }) => (
  <nav
    role="tablist"
    className={clsx(
      'flex gap-x-1 overflow-x-auto whitespace-nowrap min-w-0',
      className,
    )}
    {...rest}
  >
    {children}
  </nav>
);

NavTabs.Item = Item;

export default NavTabs;
